import { createSlice } from '@reduxjs/toolkit';

const isNavBarLocked = localStorage.getItem('lockNavBar') === 'true';

const initialState = {
  locked: isNavBarLocked,
  collapsed: isNavBarLocked,
};

const navBarCollapse = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    openNavBar: state => {
      return {
        ...state,
        collapsed: true,
      };
    },
    closeNavBar: state => {
      if (state.locked) return state;

      return {
        ...state,
        collapsed: false,
      };
    },
    toggleCollapseLock: state => {
      return {
        collapsed: !state.locked,
        locked: !state.locked,
      };
    },
  },
});

export const {
  openNavBar,
  closeNavBar,
  toggleCollapseLock,
} = navBarCollapse.actions;
export default navBarCollapse.reducer;
